import * as React from 'react';
import { type StyleProp, StyleSheet, View, type ViewStyle } from 'react-native';

import type * as api from '@gitbook/api-client';
import { Image, sizes } from '@gitbook/react-uikit';

import type { ContentKitElementProps } from './types';

export const ContentKitImageRenderContext = React.createContext<'inline' | 'block'>('block');

export function ContentKitImage(
    props: ContentKitElementProps<api.ContentKitImage> & {
        style?: StyleProp<ViewStyle>;
    }
): React.ReactElement {
    const { element, style } = props;
    const display = React.useContext(ContentKitImageRenderContext);

    return display === 'block' ? (
        <View style={[{ width: '100%', aspectRatio: element.aspectRatio }, style]}>
            <Image source={{ uri: element.source.url }} style={StyleSheet.absoluteFill} />
        </View>
    ) : (
        <Image
            source={{ uri: element.source.url }}
            style={[{ width: sizes.ICON_300, height: sizes.ICON_300 }]}
        />
    );
}
